import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    auth: null
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        login: (state, action) => {
            state.auth = action.payload;
        },
        logout: (state, action) => {
            state.auth = null;
        },
    },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
